import { timeStampToLongString } from "./stringUtils";

export const getDeviceGroupName = (device, deviceGroups) => {
    try {
        return deviceGroups[device.deviceGroupRef.id].name;
    } catch (e) {
        return undefined;
    }
};

export const getDeviceOrganizationName = (device, organizations) => {
    if (device.organizationRef) {
        let deviceOrg = organizations[device.organizationRef.id];
        if (deviceOrg) return deviceOrg.name;
    }
    return undefined;
};

export const getDeviceLastCheckInString = (device) => {
    return timeStampToLongString(device);
};

export const getDevicePUIVersion = (device) => {
    return device.manufacturer === "Pico" ? device.osDisplayVersion : undefined;
};

export const getDevicePicoControllerVersion = (device) => {
    if (device.picoCvControllerVersions) {
        return `${device.picoCvControllerVersions.controller0 || device.picoCvControllerVersions.controller2 || ''}, ${device.picoCvControllerVersions.controller1 || ''}, ${device.picoCvControllerVersions.station || ''}` // eventually can delete reference to controller2, renamed controllers from controller1/2 to 0/1
    }
    return undefined;
}
